import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Brain, Zap, PenTool, Circle, RotateCcw } from 'lucide-react';
import ThoughtBubbleIcon from '../../components/ThoughtBubbleIcon';
import SynapseSurfer from './games/SynapseSurfer';
import WritersBlockdown from './games/WritersBlockdown';
import FocusFlyer from './games/FocusFlyer';
import MindstormPinball from './games/MindstormPinball';

import ArcadeCabinet from './games/ArcadeCabinet';

const GAMES = [
    {
        id: 'focus-flyer',
        title: 'Focus Flyer',
        description: 'Navigate the neural network in this 3D rail shooter.',
        color: 'from-cyan-400 to-blue-600',
        component: FocusFlyer
    },
    {
        id: 'mindstorm-pinball',
        title: 'Mindstorm Pinball',
        description: 'High-fidelity neon pinball. Keep the thought alive.',
        color: 'from-cyan-500 to-teal-600',
        component: MindstormPinball
    },
    {
        id: 'synapse-surfer',
        title: 'Synapse Surfer',
        description: 'Ride the neural waves! Avoid cognitive overload blocks.',
        color: 'from-purple-500 to-indigo-600',
        component: SynapseSurfer
    },
    {
        id: 'writers-blockdown',
        title: "Writer's Blockdown",
        description: 'Smash through mental blocks with word power!',
        color: 'from-purple-500 to-fuchsia-600',
        component: WritersBlockdown
    }
];

const BrainBreakApp = () => {
    const navigate = useNavigate();
    const [activeGameId, setActiveGameId] = useState(null); // null = Arcade Selector
    const [showArcadeSelector, setShowArcadeSelector] = useState(true);

    const handleSelectGame = (gameId) => {
        setActiveGameId(gameId);
        setShowArcadeSelector(false);
    };

    const handleReturnToArcade = () => {
        setActiveGameId(null);
        setShowArcadeSelector(true);
    };

    const activeGame = GAMES.find(g => g.id === activeGameId);
    const ActiveComponent = activeGame ? activeGame.component : null;

    return (
        <div className="w-full h-screen flex flex-col bg-slate-900 overflow-hidden">
            {/* Header */}
            {/* Header */}
            {/* Header */}
            <header className="bg-white border-b border-gray-200 px-4 md:px-6 py-4 flex items-center justify-between z-50 backdrop-blur-md sticky top-0">
                <div
                    className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity w-1/3"
                    onClick={() => navigate('/')}
                >
                    <ThoughtBubbleIcon className="fill-blue-600 text-blue-600 shrink-0" size={24} />
                    <span className="text-sm md:text-xl font-bold md:font-extrabold text-blue-600 tracking-tight font-rounded">
                        Thoughtblink
                    </span>
                </div>

                <div className="flex justify-center w-1/3">
                    <h1 className="text-lg md:text-xl font-bold bg-gradient-to-r from-cyan-500 to-blue-600 bg-clip-text text-transparent">
                        Brain Break
                    </h1>
                </div>

                <div className="flex justify-end w-1/3">
                    {/* Game Select Button (Only visible when in a game) */}
                    {!showArcadeSelector && (
                        <button
                            onClick={handleReturnToArcade}
                            className="px-3 py-1.5 bg-slate-900 hover:bg-slate-800 text-cyan-400 font-bold rounded-lg transition-all border border-slate-700 flex items-center gap-2 text-xs tracking-wider shadow-sm"
                        >
                            <RotateCcw size={14} />
                            GAME SELECT
                        </button>
                    )}
                </div>
            </header>

            {/* Main Content Area */}
            <div className="flex-1 w-full h-full relative">
                {showArcadeSelector ? (
                    <ArcadeCabinet games={GAMES} onSelectGame={handleSelectGame} />
                ) : (
                    <div className="w-full h-full">
                        {ActiveComponent && <ActiveComponent />}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BrainBreakApp;
